// React
import { useEffect } from "react";
// React Query
import { useQueryClient } from "@tanstack/react-query";

// Hooks
import { useSubscriptions } from "@Common/context/subscriptions/Subscriptions";
import { useCommissionCyclesData } from "@Washouts/hooks/common/useCommissionCyclesData";

// Services
import { gql } from "@/services/httpAdapter";

// Types
type GPSDeviceTransferringSubscriptionArgs = {
	locationId: string | undefined;
	selectedCCId: string;
	selectedPPId: string;
	vehicleCategory: string;
};
export default function useGPSDeviceTransferringSubscription(args: GPSDeviceTransferringSubscriptionArgs) {
	const queryClient = useQueryClient();
	const { addSubscription, getSubscription, deleteSubscription } = useSubscriptions();

	const { locationId, selectedCCId, selectedPPId, vehicleCategory } = args;

	const { commissionCycle, payPeriodByDate } = useCommissionCyclesData({ date: new Date() });
	const currentCommissionCycleId = commissionCycle?._id;
	const currentPayPeriodId = payPeriodByDate?._id;

	const gpsDeviceTransferringSubscriptions = getSubscription([
		"transferGPSDevice",
		locationId,
		currentCommissionCycleId,
		currentPayPeriodId,
	]);
	gpsDeviceTransferringSubscriptions?.subscriptions?.onTransferGPSDevice?.setCallback(() => {
		queryClient.invalidateQueries({
			queryKey: ["inventory", "vehicleInventory", locationId, currentCommissionCycleId, currentPayPeriodId, vehicleCategory],
		});
	});

	useEffect(() => {
		if (locationId && currentPayPeriodId === selectedPPId && currentCommissionCycleId === selectedCCId) {
			addSubscription(
				["transferGPSDevice", locationId, currentCommissionCycleId, currentPayPeriodId],
				[
					{
						context: "onTransferGPSDevice",
						query: gql`
							subscription onTransferGPSDevice($locationId: String) {
								onTransferGPSDevice(locationId: $locationId) {
									locationId
								}
							}
						`,
						variables: {
							locationId,
						},
					},
				]
			);
		}

		return () => {
			deleteSubscription(["transferGPSDevice", locationId, currentCommissionCycleId, currentPayPeriodId]);
		};
	}, [locationId, selectedCCId, selectedPPId, currentPayPeriodId, currentCommissionCycleId]);
}
